import {streamTypes} from '../constants/streamTypes';

/**
 * @name isGameStream
 * @param {string} type - live game stream type
 */
export const isGameStream = (type) => {
  return type === streamTypes.GAME_STREAM || type === streamTypes.LIVE_EVENT;
};
